import React from 'react'

import Tooltip from '../../../../../components/atoms/Tooltip'

import useStyles from './styles'

type ShortNameProps = {
  name: string
}

const ShortName: React.FC<ShortNameProps> = ({ name = '' }) => {
  const isLong = React.useMemo(() => name.split(' ').length > 2, [name])

  const shortName = React.useMemo(() => {
    if (!isLong) {
      return name
    }

    return name.split(' ').slice(0, 2).join(' ')
  }, [isLong, name])

  const classes = useStyles()

  if (isLong) {
    return (
      <Tooltip title={name} arrow>
        <div className={classes.root}>{shortName}...</div>
      </Tooltip>
    )
  }

  return <div className={classes.root}>{name}</div>
}

export default ShortName
